'use strict';

function EMTRequestOption() {
  this.id = null;
  this.node = null;
  this.extends = [EMTController, _Paths];
  this.presenter = null;
  this._analytics = new Analytics();
  this._history = new History();

  this.classes = {
    component: '.emt-fund-option',
    section: '.emt-fund__section',
    actionPanelComponent: '.js--emt-fund-action-panel',
    actionPanel: '.emt-fund__action-panel',
    statusContainer: '.emt-fund-status__container',
    featureControlStatus: '.emt-fund-status__feature-control',
    featureDisabledToolTip: '.js--feature-disabled-tooltip'
  };

  this._viewPath = '/member/components/emt/emt-fund-option';
  this.product = null;

  this.dateFormat = {
    status: 'MMMM DD, YYYY - h:mm A z'
  };

  this.init = function () {
    // EmtOption class is the entry for emt request flow
    // clear previous latest emt request property to make "inflight" get call with no request_id
    // This inflight call will be marked as seen so terminal status's such as expire won't be persistent
    // when a request is marked by the BE, it returns null (available) status again
    this.presenter.removeModelProperty(this.EMT_LATEST_REQUEST);

    this._super();
    if (!this.product) console.error('EMTFundingOption: missing product attribute');
    this._featureIsAvailable = this.isEmtEnabled();
    this._initialize();
  };

  this.initAllReady = function () {};

  this._initialize = function () {
    var _this = this;

    this._loadTemplate();

    if (!this._featureIsAvailable) {
      this._disableComponent();
      this._pushStatusAnalytics('unavailable');
      // remove loading state
      this._removeProgressLoader();
    } else {
      $.when(this.emtRequestModelPromise).then(function () {
        _this._loadStatus();
        _this._setComputedVariables();
        _this._setEventHandlers();
        _this._pushStatusAnalytics(_this._emtStatus);
        // remove loading state when emt request model promise is resolved
        _this._removeProgressLoader();
      });
    }
    this.node.style.display = 'block';
  };

  this._loadTemplate = function () {
    var productThemeClass = 'emt-fund__container--' + this.product;

    this._emtActionPanelComponent = document.querySelector(this.classes.actionPanelComponent);
    this._loadContentful();

    this._emtFundingOptionComponent = document.querySelector(this.classes.component);
    this._emtFundingSection = document.querySelector(this.classes.section);
    this._emtFeatureControlStatus = document.querySelector(this.classes.featureControlStatus);

    this._emtFundingSection.classList.add(productThemeClass);
  };

  this._loadContentful = function () {
    this._emtActionPanelComponent.mogo().create('ActionPanel', {
      contentId: this.contentId,
      contentSpace: this.contentSpace,
      contentType: this.contentType
    });
  };

  this._setComputedVariables = function () {
    var _this2 = this;

    this.presenter.addComputedVariable('emt_request_available', ['emt.requests.' + this.emtRequestProduct + '.expiry_date'], function (val) {
      var msg = '';

      if (val) {
        var now = moment(new Date());
        var expiry = moment(val);
        var hours = moment.duration(expiry.diff(now)).hours();

        if (hours === 0) {
          var minutes = moment.duration(expiry.diff(now)).minutes();
          msg = 'Transfer expires in ' + minutes + ' mins';
        } else {
          msg = 'Transfer expires in ' + hours + ' hours';
        }
      }
      return msg;
    });

    this.presenter.addComputedVariable('emt_request_expired', ['emt.requests.' + this.emtRequestProduct + '.expiry_date'], function (val) {
      if (val) {
        var timeZone = moment.tz.guess();
        var date = moment(val).tz(timeZone).format(_this2.dateFormat.status);
        return '' + date;
      }
      return '';
    });
  };

  this._setEventHandlers = function () {
    var _this3 = this;

    this._emtActionPanelComponent.addEventListener('click', function () {
      _this3._analytics.forcePushEvent('generic-event', {
        category: ['MogoCrypto'],
        action: ['navigation'],
        label: ['interac request - instant'] // true | false
      });
      _this3._routeToNextStep(_this3._emtStatus);
    });
  };

  // https://overflow.io/s/9AVO9TZN?node=1546575e&hints=off
  this._loadStatus = function () {
    this._emtStatus = this.getEmtStatus();

    if (this.isEmtInProgress()) {
      // if it's in a progress status,
      // need to save request to latestRequest model property for request_id on status page.
      var previousRequest = this.presenter.getModelProperty(this.EMT_REQUEST_MODEL + '.' + this.product);
      this._saveLatestEmtRequest(previousRequest);
      this._emtStatusMessage = document.querySelector('.emt-fund-status--' + this._emtStatus);
      this._emtStatusContainer = document.querySelector(this.classes.statusContainer);

      this._emtStatusContainer.classList.remove('hide');
      this._emtStatusMessage.classList.remove('hide');
    }
  };

  this._routeToNextStep = function (status) {
    var url = '/';
    // if status is Null, means get_emt_request returns null for products.
    // at this state, users can create a request

    switch (status) {
      case 'COMPLETED':
      case 'FAILED':
      case 'EXPIRED':
        url = this.paths.emt[this.emtRequestProduct].amount;
        break;
      case 'PENDING':
        url = this.paths.emt[this.emtRequestProduct].status;
        break;
      case 'AVAILABLE':
        url = this.paths.emt[this.emtRequestProduct].request;
        break;
      default:
        url = this.paths.emt[this.emtRequestProduct].amount;
    }
    return this._history.goToUrl(url);
  };

  this._disableComponent = function () {
    // Add disable class when feature is unavailable, via feature controls.
    this._emtFundingOptionComponent.classList.add('disabled');
    this._emtFeatureControlStatus.classList.remove('hide');
  };

  this._pushStatusAnalytics = function (status) {
    // Available statuses from: Available, Pending, Failed, Expired
    // Disabled = `unavailable'
    var analyticsLabel = status;

    if (status === 'AVAILABLE') {
      analyticsLabel = 'incomplete';
    } else if (!status) {
      analyticsLabel = 'normal';
    }

    this._analytics.forcePushEvent('generic-event', {
      category: ['MogoCrypto'],
      action: ['instant interac status'],
      label: [analyticsLabel.toLowerCase()]
    });
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('available');
    this.presenter.removeComputedVariable('expired');
  };
}